import styled from "styled-components";

export const ContainerModalCentro = styled.div`
  width: 365px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  margin: auto;
  padding: 20px;
  .bold {
    font-weight: 500;
  }
  .container-btn {
    display: flex;
    gap: 10px;
  }
  .cancelar {
    width: 122px;
    height: 40px;
    border-radius: 8px;
    color: var(--color-white);
    font-size: 16px;
    font-weight: 500;
    box-shadow: 0 100px 80px rgb(0 0 0 / 7%),
      0 41.7776px 33.4221px rgb(0 0 0 / 5%),
      0 22.3363px 17.869px rgb(0 0 0 / 4%),
      0 12.5216px 10.0172px rgb(0 0 0 / 4%),
      0 6.6501px 5.32008px rgb(0 0 0 / 3%),
      0 2.76726px 2.21381px rgb(0 0 0 / 2%);
  }
  .btn-como-llegar {
    display: flex;
    align-items: center;
    gap: 5px;
    background-color: transparent;
    color: var(--color-latex30);
    border: 2px solid var(--color-latex30);
    border-radius: 6px;
    padding: 10px 14px;
    font-weight: bold;
    cursor: pointer;
    margin-bottom: 10px;
    transition: all 0.2s;
  }
`;
